
export default function TargetAudienceSection() {
  const audiences = [
    {
      title: 'Gemeenten',
      subtitle: 'Controle en Transparantie',
      description: 'Snel controleren of taxi-kosten binnen afspraken vallen. Voorkomen van misverstanden en snelle goedkeuring op basis van transparante berekeningen.',
      icon: 'ri-government-line',
      color: 'from-blue-500 to-blue-600',
      benefits: [
        'Directe controle op vervoerskosten',
        'Transparante kostencalculaties',
        'Snelle goedkeuringsprocedures',
        'Voorkomen van budgetoverschrijdingen',
        'Duidelijke rapportages voor beleid'
      ],
      image: 'https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/908bd87544a23b45eefff96d44596046.png'
    },
    {
      title: 'Vervoersbedrijven',
      subtitle: 'Efficiëntie en Duidelijkheid',
      description: 'Efficiënt systeem dat tijd bespaart en zorgt voor duidelijkheid richting opdrachtgevers. Gemakkelijk eerlijke en accurate offertes uitbrengen.',
      icon: 'ri-bus-line',
      color: 'from-teal-500 to-teal-600',
      benefits: [
        'Geautomatiseerde ritberekeningen',
        'Accurate offerte-generatie',
        'Tijdsbesparing in administratie',
        'Betere klantrelaties door transparantie',
        'Realtime inzicht in operationele kosten'
      ],
      image: 'https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/ef08cf7f20955dedc1e7427e809660bf.jpeg'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Voor Wie is EasyTravel?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Onze oplossing is speciaal ontwikkeld voor twee cruciale spelers in het vervoerslandschap
          </p>
        </div>

        <div className="space-y-12 sm:space-y-16">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-8 lg:gap-12 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <div className="flex items-start space-x-4 mb-6">
                  <div className={`w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br ${audience.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                    <i className={`${audience.icon} text-2xl sm:text-3xl text-white`}></i>
                  </div>
                  <div>
                    <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                      {audience.title}
                    </h3>
                    <div className="text-teal-600 font-semibold text-base sm:text-lg">
                      {audience.subtitle}
                    </div>
                  </div>
                </div>

                <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 leading-relaxed">
                  {audience.description}
                </p>

                <div className="space-y-4">
                  <h4 className="font-bold text-gray-900 text-base sm:text-lg">Belangrijkste Voordelen:</h4>
                  <div className="space-y-3">
                    {audience.benefits.map((benefit, bIndex) => (
                      <div key={bIndex} className="flex items-start space-x-3">
                        <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                        <span className="text-gray-700 leading-relaxed text-sm sm:text-base">{benefit}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''} order-first lg:order-none`}>
                <div className="relative">
                  <img
                    src={audience.image}
                    alt={audience.title}
                    className="w-full h-64 sm:h-80 object-cover object-top rounded-2xl shadow-lg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
                  <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6">
                    <div className="bg-white/95 backdrop-blur-sm rounded-lg p-3 sm:p-4 border border-gray-200">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-bold text-gray-900 text-sm sm:text-base">{audience.title}</div>
                          <div className="text-xs sm:text-sm text-gray-600">EasyTravel Gebruiker</div>
                        </div>
                        <div className="w-2 h-2 bg-teal-500 rounded-full animate-pulse"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Free Trial Section */}
        <div className="mt-16 sm:mt-20 bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-6 sm:p-8 lg:p-12 border border-teal-200">
          <div className="text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-gift-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Start met EasyTravel
            </h3>
            <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 max-w-2xl mx-auto">
              Test tot 5 ritten per maand zonder te betalen. Ideaal om kennis te maken met onze krachtige functionaliteiten.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
              <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border border-gray-200">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">Gratis Account</h4>
                <ul className="space-y-3 text-left">
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Tot 5 ritten per maand</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Volledige functionaliteit</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Geen verplichtingen</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border border-gray-200">
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">Betaald Account</h4>
                <ul className="space-y-3 text-left">
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Onbeperkt aantal ritten</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Premium support</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm sm:text-base">Geavanceerde rapportages</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
